function CertificationSection() {
  return (
    <p>
      I certify that I have been incapable of work because of the reasons stated above, on the
      dates shown and that this information is true and accurate. I acknowledge that false
      information will result in disciplinary action.I hereby give my employer permission to
      verify the above information.
    </p>
  )
}

export default CertificationSection